import { CaretDownOutlined } from "@ant-design/icons";
import { Row, Select } from "antd";
import React from "react";

export interface IDeskSelectProps {
  code: string;
  handleChangeType: Function;
  currentValue: any;
  currentFeature: any;
}

export const DESK = "DESK";
export const CABINET = "CABINET";

export const DESK_OPTIONS = {
  [DESK]: [
    { key: 1, value: false, label: "Bộ không kèm bàn Sofa" },
    { key: 2, value: true, label: "Bộ kèm 01 bàn Sofa" },
  ],
  [CABINET]: [
    {
      key: 1,
      value: false,
      label: "Bộ không kèm tủ đầu giường",
      label2: "Bộ không kèm tủ + đôn giường",
    },
    {
      key: 2,
      value: true,
      label: "Bộ kèm 02 tủ đầu giường",
      label2: "Bộ kèm 02 tủ + 01 đôn giường",
    },
  ],
};

const DeskSelect = (props: IDeskSelectProps) => {
  const { code, handleChangeType, currentValue, currentFeature } = props;

  return (
    <>
      <Row justify="center">
        <Select
          virtual={false}
          value={currentValue}
          onChange={handleChangeType}
          className="product-item-select product-item-select--left"
          dropdownClassName="product-item-select__dropdown"
          suffixIcon={
            <CaretDownOutlined
              style={{
                color: "#0c3b5d",
              }}
              className={"flicker-color"}
            />
          }>
          {DESK_OPTIONS[code].map((item: any) => (
            <Select.Option
              key={item.key}
              value={item.value}
              className="product-item-select__option">
              <span className="product-item-select__label">
                {currentFeature?.product_props?.find(
                  (p: any) => p.code === "LOAI"
                )?.is_special_bed
                  ? item.label2
                  : item.label}
              </span>
            </Select.Option>
          ))}
        </Select>
      </Row>
    </>
  );
};

export default DeskSelect;
